import 'react-perfect-scrollbar/dist/css/styles.css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { colors, ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles'
import theme from 'src/theme';
import routes from 'src/routes';
import { history } from './_helpers';
import { alertActions } from './_actions';
import{Button, Snackbar, } from '@material-ui/core'
import AlertSnack from './components/Alert';


const  App = () => {
  const alert = useSelector(state => state.alert);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
      history.listen((location, action) => {
          // clear alert on location change
          dispatch(alertActions.clear());
      });
  }, []);

 //const routing = useRoutes(routes);
 const isLogging =() =>
 {
  if(!localStorage.getItem('user')) {
    return false;
  }
  else{
    return true;
  }
 } 

/*<Snackbar
open         
autoHideDuration={6000}
message={alert.message}        
className={'alert ${alert.type}'}
onClose={handleClose}
/>*/   
 const routing = useRoutes(routes(isLogging()));
 return (  
   <ThemeProvider theme={theme}>     
     <GlobalStyles />    
     <div> 
     {alert.message  && 
     <AlertSnack
    autoclose={4000}
    message={alert.message}        
    type={alert.type}
    />
   
    }
    </div>     
     {routing}
   </ThemeProvider>  
 );
};
export default App;
